export const langFr = {
  html_title: 'AlcmeonChat',
  title: 'Vos conseillers à distance',
  subtitle: 'Nous répondons à toutes vos questions - ',
  privacy_link_prefix: 'Vous pouvez accéder à notre politique de confidentialité',
  privacy_link_label: 'ici',
  send_a_message: 'Envoyez un message...',
  send_your_email: 'Saisissez votre adresse email...',
  send_your_phone: 'Envoyez votre numéro de téléphone, au format +33612345678',
  select_an_option: 'Sélectionnez une option',
  close_menu: 'Fermer le menu',
  'aria_label/close': 'fermer',
  'aria_label/close-menu': 'fermer le menu',
  'aria_label/file-upload': 'télécharger une image ou un document PDF',
  'aria_label/open_alcmeon_inmessage': 'ouvrir le chat',
  'aria_label/options': 'options',
  'aria_label/send_message': 'envoyer le message',
  'alt/an_image': 'une image',
  helperMessage1: `Bonjour 🙂<br/>Vous avez une question ?`,
  helperMessage2: `Nous sommes là pour vous aider.`,
  helperMessage3: `<strong>Vous avez une conversation en cours</strong>`,
  helperMessage4: `Continuez ici 👉`,
  waitingMessage: `Un conseiller vous répondra prochainement. Vous êtes actuellement en position {{position}}. Votre temps d'attente estimé est de {{time}}, merci de patienter.`,
  lessThan:'moins de',
  moreThan:'plus de',
  minutes:'min'
};
